import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormBackground } from '../../../AdminRoutes/CreateRoutes/CreateForm.styles';
import PrimaryButtonComponent from '../../../Components/Buttons/PrimaryButton/PrimaryButton.component';
import InputText from '../../../Components/Form/InputText';
import { httpResendAccountDetails } from '../../../Hooks/company/company.post.hooks';

const ResentLoginEmail = ({ user }) => {
  const [status, setStatus] = useState('');
  const [newPassword, setNewPassword] = useState('');
  // console.log('ResentLoginEmail user:', user);

  const resetPassword = async (e) => {
    e.preventDefault();
    setStatus('Sending email...');
    try {
      const response = await httpResendAccountDetails(
        user.email,
        newPassword,
        user._id
      );
      if (response.ok) {
        setStatus('Email sent successfully');
      } else {
        const errorData = await response.json();
        setStatus(errorData.msg || 'Failed to send email');
      }
    } catch (error) {
      console.error('Error sending email:', error);
      setStatus('Error sending email');
    }
  };
  return (
    <FormBackground>
      <h4>Resend Login Emails</h4>
      <p>
        To resend the user login, create a new password and press send. The user
        will be updated with the new password and an email will be sent to the
        user with a new password.
      </p>
      <form onSubmit={resetPassword}>
        <div className="inputGroup">
          <InputText
            type="password"
            placeholder="New Password"
            value={newPassword}
            setValue={setNewPassword}
            required
          />
        </div>
        <div className="buttonGroup">
          <PrimaryButtonComponent
            span="Send Login Email"
            functionName={resetPassword}
          />
        </div>
      </form>
      {status && <p className="statusMessage">{status}</p>}
    </FormBackground>
  );
};
ResentLoginEmail.propTypes = {
  user: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
  }).isRequired,
};

export default ResentLoginEmail;
